import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=541dbdf3&scoped=true&"
import script from "./TheAlert.vue?vue&type=script&lang=js&"
export * from "./TheAlert.vue?vue&type=script&lang=js&"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=541dbdf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541dbdf3",
  null
  
)

export default component.exports